import { message } from 'antd';
import {
  queryList,
  salaryDelete,
  recall,
  queryStatusList,
  publish,
  remind,
  detail,
  verifyPwd,
} from '@/services/salary/manage';
import { SALARY_CAT_NO_AUTH, VERIFY_PWD_SUCCESS } from '../constants';
import { noAuthCat } from '../utils/utils';

const initState = () => {
  return {
    statusList: [],
    list: [],
    queries: {
      sentState: "",
      subContent: ""
    }, // 搜索查询条件
    // 分页信息
    pageInfo: {
      page: 1,
      pageSize: 10,
      totalElements: 1,
      totalPages: 1
    },
    // 加载信息
    spinProps: {
      spinning: false,
      tip: "加载中..."
    },
    detailsData: {},
    // 是否可以查看工资条 1231505 -> 需要密码验证 1231506 -> 输错密码超过阈值（10次）
    salaryCatAuth: 0,
    // 控制密码输错超过10次“锁定弹框”显示
    lockedVisible: false,
    // 控制需要密码验证弹框显示
    pwdVisible: false,
    accessToken: '',
  };
};



export default {
  namespace: "manage",

  state: initState(),

  effects: {
    // 获取列表信息
    *fetchList({ payload }, { call, put, select }) {
      try {
        // 页面定时刷新不需要加载中动画
        const { reFresh = true } = payload;
        if (reFresh) {
          yield put({
            type: "save",
            payload: {
              spinProps: {
                spinning: true,
                tip: "加载中..."
              }
            }
          });
        }

        // 判断上次操作是否为查询  是则 获取数据的page字段改为 1
        const { isSearch, sentState, accessToken } = yield select(state => state.manage);

        let params = { ...payload, sentState, accessToken };

        if (isSearch !== false) {
          params = Object.assign({}, params, {
            page: 1
          });
        }
        const [response, statusList] = yield [
          call(queryList, params),
          call(queryStatusList)];

        const { content, page, pageSize, totalElements, totalPages, code: salaryCatAuth } = response;
        // 是否有权限查看
        if (noAuthCat(salaryCatAuth)) {
          yield put({
            type: "save",
            payload: {
              spinProps: {
                spinning: false
              },
              salaryCatAuth,
              pwdVisible: salaryCatAuth === SALARY_CAT_NO_AUTH,
            }
          });
        } else {
          yield put({
            type: "save",
            payload: {
              statusList: statusList.slice(1),
              list: content,
              pageInfo: {
                page,
                pageSize,
                totalElements,
                totalPages
              },
              isSearch: false,
              sentState,
              spinProps: {
                spinning: false
              },
              salaryCatAuth: 0,
              pwdVisible: false,
            }
          });
        }
      } catch (error) {
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: false
            }
          }
        });
      }
    },
    *fetchSearch({ payload }, { call, put, select }) {
      try {
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: true,
              tip: "加载中..."
            }
          }
        });
        const { accessToken } = yield select(state => state.manage);
        const response = yield call(queryList, { ...payload, accessToken });

        const {
          content,
          page,
          pageSize,
          totalElements,
          totalPages,
          code: salaryCatAuth,
        } = response;
        if (noAuthCat(salaryCatAuth)) {
          yield put({
            type: "save",
            payload: {
              spinProps: {
                spinning: false
              },
              salaryCatAuth,
              pwdVisible: salaryCatAuth === SALARY_CAT_NO_AUTH,
            }
          });
        } else {
          yield put({
            type: "save",
            payload: {
              list: content,
              pageInfo: {
                page,
                pageSize,
                totalElements,
                totalPages
              },
              spinProps: {
                spinning: false
              },
              salaryCatAuth: 0,
              pwdVisible: false,
            }
          });
        }
      } catch (error) {
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: false
            }
          }
        });
      }
    },
    // 删除
    *fetchDel({ payload }, { call, put, select }) {
      try {
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: true,
              tip: "删除中..."
            }
          }
        });
        yield call(salaryDelete, payload);
        message.info("删除成功");
        const { pageInfo, queries } = yield select(state => state.manage);
        const { page, pageSize } = pageInfo;
        yield put({
          type: "fetchSearch",
          payload: {
            page,
            pageSize,
            ...queries
          }
        });

        return Promise.resolve();
      } catch (error) {
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: false
            }
          }
        });
        return Promise.reject();
      }
    },
    *fetchRequest({ payload }, { call, put, select }) {
      try {
        const fetchMap = {
          "recall": { request: recall, tip: "撤回" },
          "publish": { request: publish, tip: "发布" },
          "remind": { request: remind, tip: "提醒" }
        };

        const { fetchType } = payload;
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: true,
              tip: `${fetchMap[fetchType].tip}中...`
            }
          }
        });

        yield call(fetchMap[fetchType].request, payload);
        message.success(`${fetchMap[fetchType].tip}成功`);

        const { pageInfo, queries } = yield select(state => state.manage);
        const { page, pageSize } = pageInfo;

        yield put({
          type: "fetchSearch",
          payload: {
            page,
            pageSize,
            ...queries
          }
        });

        return Promise.resolve();
      } catch (error) {
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: false
            }
          }
        });
        return Promise.reject();
      }
    },
    // 详情
    *fetchDetail({ payload }, { call, put, select }) {
      try {
        const { accessToken } = yield select(state => state.manage);
        const { code: salaryCatAuth, ...data } = yield call(detail, { ...payload,  accessToken });
        const { contentTitle = [], content = [] } = data
        const columns = []
        const dataSource = [];
        contentTitle.map((item, index) => {
          if(item.trim().length){
            let a = {};
            a.title = item;
            a.dataIndex = `columns${index}`;
            a.key = `columns${index}`;
            a.width = 130;
            a.render = data => {
              if (!data) {
                return '-';
              }
              return data
            }
            columns.push(a);
          }
        });
        content.map(item => {
          const { salarySheetDetailExtendValue } = item;
          let b = {};
          salarySheetDetailExtendValue.map((subitem, index) => {
            b['columns' + index] = subitem;
          });
          dataSource.push(b);
        })
        data.columns = columns;
        data.dataSource = dataSource;

        if (noAuthCat(salaryCatAuth)) {
          yield put({
            type: 'save',
            payload: {
              salaryCatAuth,
              pwdVisible: salaryCatAuth === SALARY_CAT_NO_AUTH,
            }
          });
        } else {
          yield put({
            type: "save",
            payload: {
              detailsData: data,
              salaryCatAuth: 0,
              pwdVisible: false,
            }
          });
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.reject();
      }
    },
    // 密码校验
    *verifyPassword({ payload }, { call, put }) {
      try {
        const { id, type, ...params } = payload;
        const { accessToken, checkoutResult, remainingErrorTimes: leftTimes } = yield call(verifyPwd, params);
        if (checkoutResult === VERIFY_PWD_SUCCESS) {
          yield put({
            type: 'save',
            payload: {
              pwdVisible: false,
              salaryCatAuth: 0,
              accessToken,
            }
          });
          // type为list时说明是在列表页调用确认密码
          if (type === 'list') {
            yield put({
              type: 'fetchSearch',
              payload: {
                page: 1,
                pageSize: 10,
              }
            });
          } else {
            yield put({
              type: 'fetchDetail',
              payload: {
                id,
                page: 1,
                pageSize: 10,
              }
            });
          }
        } else if (Number(leftTimes) > 0) {
          message.error(`密码输入错误，剩余可输入次数${leftTimes}`, 2);
        } else {
          // 密码输错超过10次
          yield put({
            type: 'save',
            payload: {
              pwdVisible: false,
              lockedVisible: true,
            }
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    }
  }
};
